import { Box, styled } from '@mui/material';

export const ModalIndicatorContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});
